import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const getRelatedProducts = async (id, pagenum) => {
  try {
    const res = await axios({
      method: "post",
      url: baseurl + `/relatedProducts?page=1&limit=${pagenum}`,
      data: {
        productId: id,
      },
    });
    return res.data.data;
  } catch (error) {
    console.log(error);
  }
};
